import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NewsletterSubscribersService, Credentials } from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { PopinAuthShowed, RegisterNewsletter } from '@app/core/user/store/actions';
import { LocaleService } from '@app/core/i18n';

const promosByCountry = {
  FR: '30€',
  US: '$25',
  UK: '£25',
  DE: '30€',
  ES: '30€',
  IT: '20€',
  DK: '230DKK',
  FI: '30€',
  SE: '320SEK',
  WW: '$20',
  ROE: '30€',
  SG: 'S$30',
  HK: 'HK$200',
  AU: 'AU$30'
};

@Component({
  selector: 'vc-form-newsletter',
  templateUrl: './form-newsletter.component.html',
  styleUrls: ['./form-newsletter.component.scss']
})
export class FormNewsletterComponent implements OnInit {
  @Output()
  onUserValidated = new EventEmitter<Credentials>();
  @Input()
  popinForced: boolean;

  public isMobile = false;

  public pending: boolean;
  public error: string;

  public newsletterForm: FormGroup;
  public email: FormControl;
  public opted: FormControl;

  public promoOffer = '';

  public registerCgu = new FormControl('');

  constructor(
    private ref: ChangeDetectorRef,
    private newsletterSubscribersService: NewsletterSubscribersService,
    private store: Store<IAppState>,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.promoOffer = promosByCountry[this.localeService.getRegionCode()];
    this.createFormControls();
    this.createForm();

    this.store.dispatch(new RegisterNewsletter(null));

    this.store.select('device').subscribe(
      res => {
        if (res) {
          this.isMobile = !res.isMdUp;
        }
      },
      err => {}
    );
    this.store.dispatch(
      new PopinAuthShowed({
        type: 'join',
        forced: this.popinForced,
        isMobile: this.isMobile
      })
    );
  }

  createFormControls() {
    this.email = new FormControl('', [
      Validators.required,
      Validators.pattern(`^[\\w.-]+(\\+[\\w.-]+)?@[\\w.-]+\\.[a-zA-Z]{2,6}$`)
    ]);
    this.opted = new FormControl(true);
  }

  createForm() {
    this.newsletterForm = new FormGroup({
      email: this.email,
      opted: this.opted
    });
  }

  onSubmit() {
    this.pending = true;

    if (this.newsletterForm.valid) {
      if (this.opted.value) {
        this.newsletterSubscribersService
          .subscribeNewsletter({ email: this.email.value, opted: this.opted.value })
          .subscribe(
            res => {
              this.onUserValidated.emit({ email: this.email.value } as Credentials);
              this.pending = false;
            },
            httpErrorRes => {
              this.error = httpErrorRes.error.errors.detail;
              this.pending = false;
            }
          );
      } else {
        this.onUserValidated.emit({ email: this.email.value } as Credentials);
        this.pending = false;
      }
    }
  }

  setErrorMessage(status: any): void {
    // NEED TO TRANSLATE THIS ERROR MESSAGES

    switch (status) {
      case 409:
        this.error = 'Already exists';
        break;
      case 400:
        this.error = 'The request was invalid or cannot be otherwise served.';
        break;
      default:
        this.error = 'An error has occurred trying to process your request. Please try again later';
    }

    this.ref.detectChanges();
  }

  setUserFromFacebook(user: Credentials) {
    this.onUserValidated.emit(user);
  }
}
